const buns = [
    {
        name: 'burgerking_sesame',
        description: 'Burger King Bun',
        index: 0
    },
    {
        name: 'carlsjr_standard',
        description: 'Carls Jr Bun',
        index: 1
    },
    {
        name: 'innout_standard',
        description: 'In N Out Bun',
        index: 2
    },
    {
        name: 'jack_baconultimate',
        description: 'Jack in the Box Standard Bun',
        index: 3
    },
    {
        name: 'jack_butteryjack',
        description: 'Jack in the Box Buttery Jack Bun',
        index: 4
    },
    {
        name: 'jack_sourdough',
        description: 'Jack in the Box Sourdough Bun',
        index: 5
    },
    {
        name: 'mcdonalds_artisan',
        description: 'McDonalds Artisan Bun',
        index: 6
    },
    {
        name: 'mcdonalds_mcgriddle',
        description: 'McDonalds McGriddle Bun',
        index: 7
    },
    {
        name: 'mcdonalds_mcmuffin',
        description: 'McDonalds McMuffin Bun',
        index: 8
    },
    {
        name: 'mcdonalds_sesame',
        description: 'McDonalds Sesame Bun',
        index: 9
    },
    {
        name: 'mcdonalds_standard',
        description: 'McDonalds Standard Bun',
        index: 10
    },
    {
        name: 'wendys_standard',
        description: 'Wendys Bun',
        index: 11
    }
]


const sauces = [
    {
        name: 'innout_spread',
        description: 'In n Out Spread',
        index: 0
    },
    {
        name: 'mcdonalds_bigmacsauce',
        description: 'McDonalds Big Mac Sauce',
        index: 1
    },
    {
        name: 'carlsjr_bigtwinsauce',
        description: 'Carls Jr Big Twin Sauce',
        index: 2
    },
    {
        name: 'burgerking_whoppersauce',
        description: 'Burger King Whopper Sauce',
        index: 3
    },
    {
        name: 'jack_secretsauce',
        description: 'Jack in the Box Secret Sauce',
        index: 4
    },
    {
        name: 'jack_tacosauce',
        description: 'Jack in the Box Taco Sauce',
        index: 5
    },
    {
        name: 'wendys_sawesomesauce',
        description: 'Wendys Sawesome Sauce',
        index: 6
    }
]


const fillings = [
    {
        name: 'burgerking_baconking',
        description: 'Burger King Bacon King',
        index: 0
    },
    {
        name: 'burgerking_chickenfries',
        description: 'Burger King Chicken Fries',
        index: 1
    },
    {
        name: 'burgerking_doublecheeseburger',
        description: 'Burger King Double Cheeseburger',
        index: 2
    },
    {
        name: 'burgerking_hersheyspie',
        description: 'Burger King Hersheys Sundae Pie',
        index: 3
    },
    {
        name: 'burgerking_whopper',
        description: 'Burger King Whopper',
        index: 4
    },
    {
        name: 'carlsjr_doublewesternbacon',
        description: 'Carls Jr Double Western Bacon',
        index: 5
    },
    {
        name: 'carlsjr_jalapenopopper',
        description: 'Carls Jr Jalapeno Poppers',
        index: 6
    },
    {
        name: 'carlsjr_superstar',
        description: 'Carls Jr Super Star',
        index: 7
    },
    {
        name: 'innout_animalstylefries',
        description: 'In N Out Animal Style Fries',
        index: 8
    },
    {
        name: 'innout_doubledouble',
        description: 'In N Out Double Double',
        index: 9
    },
    {
        name: 'innout_neopolitan',
        description: 'In N Out Neopolitan Shake',
        index: 10
    },
    {
        name: 'jack_baconswissbuttery',
        description: 'Jack in the Box Bacon & Swiss Butter Jack',
        index: 11
    },
    {
        name: 'jack_curlyfries',
        description: 'Jack in the Box Curly Fries',
        index: 12
    },
    {
        name: 'jack_doubleultimatebacon',
        description: 'Jack in the Box Ultimate Bacon',
        index: 13
    },
    {
        name: 'jack_minitacos',
        description: 'Jack in the Box Tiny Tacos',
        index: 14
    },
    {
        name: 'jack_sourdoughjack',
        description: 'Jack in the Box Sourdough Jack',
        index: 15
    },
    {
        name: 'jack_spicychicken',
        description: 'Jack in the Box Spicy Chicken',
        index: 16
    },
    {
        name: 'mcdonalds_bigmac',
        description: 'McDonalds Big Mac',
        index: 17
    },
    {
        name: 'mcdonalds_crispychicken',
        description: 'McDonalds Crispy Chicken',
        index: 18
    },
    {
        name: 'mcdonalds_filetofish',
        description: 'McDonalds Filet o Fish',
        index: 19
    },
    {
        name: 'mcdonalds_mcdouble',
        description: 'McDonalds McDouble',
        index: 20
    },
    {
        name: 'mcdonalds_mcgriddle',
        description: 'McDonalds McGriddle',
        index: 21
    },
    {
        name: 'mcdonalds_mcmuffin',
        description: 'McDonalds McMuffin',
        index: 22
    },
    {
        name: 'mcdonalds_mcnuggets',
        description: 'McDonalds McNuggets',
        index: 23
    },
    {
        name: 'mcdonalds_mcrib',
        description: 'McDonalds McRib',
        index: 24
    },
    {
        name: 'wendys_baconator',
        description: 'Wendys Baconator',
        index: 25
    },
    {
        name: 'wendys_chili',
        description: 'Wendys Chili',
        index: 26
    },
    {
        name: 'wendys_davesdouble',
        description: 'Wendys Daves Double',
        index: 27
    },
    {
        name: 'wendys_spicychicken',
        description: 'Wendys Spicy Chicken',
        index: 28
    }
]


export {
    buns,
    sauces,
    fillings
}